import { styled } from "@mui/material/styles";

// Components
import { Box, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "SearchBar";

export const StyledBarWrapper = styled(Box, { name: styledName })({
  "&": {
    height: "80px",
    minHeight: "80px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
  },
});

export const StyledSearchInput = styled(TextField, { name: styledName })({
  "&": {
    width: "100%",
    maxWidth: "400px",
    minWidth: "200px",
    flexShrink: "1",
    "& .MuiInputBase-root": {
      fontSize: "1.4rem",
      backgroundColor: "white",
      border: "none",
      width: "100%",

      height: "40px",
      borderRadius: "6px",

      "&::before": {
        borderBottom: `2px solid ${theme.palette.primary.dark} !important`,
      },
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "solid 1px",
        borderColor: theme.palette.primary.main,
      },
    },
  },
});

export const StyledSearchIcon = styled(SearchIcon, { name: styledName })({
  "&": {
    color: theme.palette.grey[600],
    marginRight: "10px",
  },
});
